const imagePresenter = {
  useFlagInstead: (src) => { return !src || src === '' || (src.indexOf('DEFAULT') > -1) }
}

export default imagePresenter
